export default "__VITE_ASSET__B1V5A9it__"